import { createSelector } from 'reselect';

const selectFeatures = (state: any) => state.features;


export const selectFeaturesCurrentItem = createSelector([selectFeatures], (features) => features.current);

export const selectFeaturesListItems = createSelector([selectFeatures], (features) => features.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectFeaturesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectFeaturesQueryItems = createSelector([selectFeatures], (features) => features.query);

export const selectFeaturesCreatedItem = createSelector([selectFeatures], (features) => features.create);

export const selectFeaturesUpdatedItem = createSelector([selectFeatures], (features) => features.update);

export const selectFeaturesReadItem = createSelector([selectFeatures], (features) => features.read);

export const selectFeaturesDeletedItem = createSelector([selectFeatures], (features) => features.delete);

export const selectFeaturesSearchedItems = createSelector([selectFeatures], (features) => features.search);

export const selectFeaturesItemsCount = createSelector([selectFeatures], (features) => features.count);

export const selectFeaturesItemsFilter = createSelector([selectFeatures], (features) => features.filter);